import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={20} height={14} viewBox="0 0 20 14" fill="none" {...props}>
      <Path
        d="M0 5.45v5.176a2.699 2.699 0 002.699 2.699H17.3a2.699 2.699 0 002.699-2.7V5.45a.47.47 0 00-.47-.47H.47a.47.47 0 00-.47.47zm4.993 3.285H3.742a.821.821 0 110-1.642h1.251a.821.821 0 010 1.642zM20 2.868v-.17A2.699 2.699 0 0017.301 0H2.7A2.699 2.699 0 000 2.699v.17c0 .259.21.469.47.469h19.06c.26 0 .47-.21.47-.47z"
        fill="#E40046"
      />
    </Svg>
  );
}

export default SvgComponent;
